import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { OrderForm } from '../../models/orderForm';

const API_URL = (window as any)["process_env"].API_URL;

const GET_BUMP_OFFERS = 'orderforms/bumpoffers';
const GET_UPSELLS = 'orderforms/upsells';
const GET_FUNNEL = 'orderforms/funnel';


@Injectable({providedIn: 'root'})
export class TouchcrApiOrderformProvider {

  constructor(
    public http: HttpClient
  ) {
  }

  getBumpOffers(route:any): Observable<OrderForm[]> {
    return this.http.get<OrderForm[]>(`${API_URL}${GET_BUMP_OFFERS}/${route}`)
      .pipe(
        catchError((error) => {
          return throwError(error && error.error && error.error.error);
        })
      );
  }

  getUpsells(route:any): Observable<OrderForm[]> {
    return this.http.get<OrderForm[]>(`${API_URL}${GET_UPSELLS}/${route}`)
      .pipe(
        catchError((error) => {
          return throwError(error && error.error && error.error.error);
        })
      );
  }

  getFunnel(route:any): Observable<OrderForm> {
    return this.http.get<OrderForm>(`${API_URL}${GET_FUNNEL}/${route}`)
      .pipe(
        catchError((error) => {
          return throwError(error && error.error && error.error.error);
        })
      );
  }
}
